<template>
  <div class="diary">
      <div class="top">
        <div class="wrap">
        <!-- <div class="title">{{ diary.title || "" }}</div> -->
          <div class="page-selection" v-show="pages.length > 1">
            <div class="page-label" v-bind:class="{ active: page == current_page }" v-on:click="switch_page(page)" v-for="page in pages" v-bind:key=page>{{page}}</div>
          </div>
        </div>
      </div>
    <div class="wrap">
      <div class="content">
        <content-section v-for="section in content.sections" :content="section" v-bind:key=section.id></content-section>
      </div>
    </div>
  </div>
</template>

<script>
import ContentSection from '../common/Content'
export default {
  components: {
    ContentSection
  },
  data: () => {
    return {
      message: "",
      pages: [],
      current_page: "test"
    }
  },
  computed: {
    diary() {
      if(this.$store.state.diary) {
        return this.$store.state.diary
      }
    },
    content() {
      if(this.$store.state.diary.content) {
        if(this.pages.length > 0) {
          return this.$store.state.diary.content.find((elem) => {
            return elem.page == this.current_page
          })
        } else {
          return this.$store.state.diary.content[0]
        }
      } else {
        return []
      }
    }
  },
  methods: {
    switch_page(page) {
      this.current_page = page
    }
  },
  created: function() {
    this.$store.dispatch('fetchDiary', this.$route.params.key).then(() => {
      this.pages = this.$store.state.diary.content.map((elem) => {
        return elem.page
      }).filter((elem) => elem)
      this.current_page = this.pages[0]
	  }, () => {
      this.$router.push({ path: '/diary' })
    })
  }
}
</script>
